var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop-zone-cancel",class:{ active: _vm.active, droppable: true },attrs:{"title":_vm.$t('canvas.dropZoneCancel')},on:{"dragover":_vm.dragover,"drop":_vm.drop}})}
var staticRenderFns = []

export { render, staticRenderFns }